<template>
  <svg
    viewBox="0 0 24 24"
    width="18"
    height="18"
    fill="none"
    stroke="currentColor"
    stroke-width="1.7"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M5 21V4c4-4 10 4 14 0v10c-4 4-10-4-14 0" />
  </svg>
</template>
<style scoped>
svg {
  flex-shrink: 0;
}
</style>
